import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { NgxCurrencyDirective } from 'ngx-currency';

import { MaterialModule } from '../material/material.module';
import { BotaoComponent } from './botao/botao.component';
import { CardComponent } from './card/card.component';
import { HeaderComponent } from './header/header.component';
import { InputComponent } from './input/input.component';
import { LayoutComponent } from './layout/layout.component';
import { LoaderComponent } from './loader/loader.component';
import { MenuComponent } from './menu/menu.component';
import { PaginacaoComponent } from './paginacao/paginacao.component';
import { PopupFiltroComponent } from './popup-filtro/popup-filtro.component';
import { SubtituloComponent } from './subtitulo/subtitulo.component';
import { TabelaComponent } from './tabela/tabela.component';
import { TabelaFormComponent } from './tabela-form/tabela-form.component';
import { TituloComponent } from './titulo/titulo.component';
import { VoltarComponent } from './voltar/voltar.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FooterComponent } from './footer/footer.component';
import { IconsModule } from 'src/app/shared/icons.module';
import { ProgressBarComponent } from 'src/app/pages/(Empresa)/agendamento/cadastro-agendamento/components/progress-bar/progress-bar.component';

@NgModule({
  declarations: [
    BotaoComponent,
    CardComponent,
    HeaderComponent,
    InputComponent,
    LayoutComponent,
    LoaderComponent,
    MenuComponent,
    PaginacaoComponent,
    PopupFiltroComponent,
    SubtituloComponent,
    TabelaComponent,
    TabelaFormComponent,
    TituloComponent,
    VoltarComponent,
    FooterComponent,
    ProgressBarComponent
  ],
  imports: [
    MatTooltipModule,
    CommonModule,
    FormsModule,
    IconsModule,
    NgxCurrencyDirective,
    NgxMaskModule.forRoot(),
    MaterialModule
  ],
  exports: [
    BotaoComponent,
    CardComponent,
    HeaderComponent,
    InputComponent,
    LayoutComponent,
    LoaderComponent,
    MenuComponent,
    PaginacaoComponent,
    PopupFiltroComponent,
    SubtituloComponent,
    TabelaComponent,
    TabelaFormComponent,
    TituloComponent,
    VoltarComponent,
    FooterComponent,
    MaterialModule,
    ProgressBarComponent
  ]
})
export class ComponentsModule {}
